import React, { useState, useEffect } from "react";
import { View, Text, useWindowDimensions } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, Link } from "react-router-dom";
import { LoginUser } from "../redux/actions/auth";
import LoadingScreen from "../components/LoadingScreen";
import InputField from "../components/InputField";
import SimpleButton from "../components/SimpleButton";
import { Stack, Typography } from "@mui/material";
import info from "../../package.json";

const Login = () => {
  const { width } = useWindowDimensions();
  const isMobile = width < 800;
  let history = useHistory();
  let _location = useLocation();
  let { from } = _location.state || { from: { pathname: "/" } };

  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);

  const { isAuthenticated, login_error, loading } = useSelector((state) => ({
    isAuthenticated: state.auth.isAuthenticated,
    login_error: state.auth.login_error,
    loading: state.auth.loading,
  }));

  const dispatch = useDispatch();

  const _handleLogin = () => {
    dispatch(LoginUser(username, password));
  };

  useEffect(() => {
    if (login_error) {
      setUsername("");
      setPassword("");
    }
  }, [login_error]);

  useEffect(() => {
    if (isAuthenticated) {
      history.replace(from);
      window.location.reload();
    }
  }, [history, from, isAuthenticated]);

  return (
    <Stack style={{}}>
      {loading && <LoadingScreen />}

      <Stack
        sx={{
          flexDirection: { md: "row", xs: "column" },
          height: "100vh",
          width: "100vw",
        }}
      >
        <Stack
          sx={{
            display: "flex",
            backgroundColor: "#21212e",
            paddingStart: "6em",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
          }}
        >
          <Stack>
            <Typography
              style={{
                fontSize: isMobile ? "52px" : "70px",
                color: "#fff",
                textAlign: "left",
                lineHeight: "110%",
              }}
            >
              Analyst {<br />}Portal
            </Typography>
            <Typography
              style={{
                fontSize: isMobile ? "14px" : "18px",
                textAlign: "left",
                color: "#fff",
                marginTop: 3,
              }}
            >
              Integrated analysis,{<br />}review & ticketing portal
            </Typography>
          </Stack>
        </Stack>

        <Stack
          style={{
            // backgroundColor: isMobile && "#21212e",
            justifyContent: "center",
            alignItems: "center",
            flex: 1.5,
            filter: loading && "blur(3px)",
          }}
        >
          <Text
            style={{
              color: "rgba(9, 16, 29, 1)",
              fontSize: "1.2rem",
              fontWeight: "400",
              textAlign: "center",
              marginBottom: "5px",
            }}
          >
            Login To Continue
          </Text>
          <InputField
            onChangeText={(text) => setUsername(text)}
            icon="username"
            placeholder="User Name"
            value={username}
          />
          <InputField
            onChangeText={(text) => setPassword(text)}
            icon="password"
            placeholder="Password"
            secureTextEntry={true}
            value={password}
          />
          <View style={styles.buttonWrapper}>
            <Link to="/resetpassword" style={{ textDecorationLine: "none" }}>
              {/* <Text style={styles.forgotText}>Forgot Password?</Text> */}
            </Link>

            <View
              style={{
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <SimpleButton onPress={() => _handleLogin()} />
            </View>
          </View>
          <View style={{ alignItems: "center" }}>
            {login_error && (
              <Text style={[styles.forgotPass, {}]}>
                Access Denied ! Invalid credentials.
              </Text>
            )}
          </View>
        </Stack>
      </Stack>

      <div
        style={{
          position: "fixed",
          right: 5,
          bottom: 5,
          margin: 10,
        }}
      >
        <Text style={{ fontFamily: "Roboto", fontSize: 12 }}>
          v {info.version}
        </Text>
      </div>
    </Stack>
  );
};

const styles = {
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  buttonWrapper: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  forgotText: {
    flex: 1,
    textAlign: "left",
    fontFamiily: "Roboto",
    letterSpacing: 1,
    opacity: 0.7,
    fontSize: 14,
  },
  forgotPass: {
    color: "red",
    opacity: 0.8,
  },
};

export default Login;
